import { ACTION_CONSTANTS } from 'actions/constants';
import { uuid } from 'util/baseUtil';

export const MODAL_TYPES = {
  alert: 1,
  confirm: 2,
  custom: 3,
  error: 4
};

export function openCustomModal(props = {}) {
  props.key = uuid();
  props.modalType = MODAL_TYPES.custom;
  return dispatch => {
    return dispatch({ type: ACTION_CONSTANTS.modals.open, payload: { props } });
  };
}

export function openConfirmModal(props = {}) {
  props.key = uuid();
  props.modalType = MODAL_TYPES.confirm;
  return dispatch => {
    return dispatch({ type: ACTION_CONSTANTS.modals.open, payload: { props } });
  };
}

export function openAlertModal(props = {}) {
  props.key = uuid();
  props.modalType = MODAL_TYPES.alert;
  return dispatch => {
    return dispatch({ type: ACTION_CONSTANTS.modals.open, payload: { props } });
  };
}

// reducer only allows one error modal visibile at a time
export function openErrorModal(props = {}) {
  props.key = uuid();
  props.modalType = MODAL_TYPES.error;
  return dispatch => {
    return dispatch({ type: ACTION_CONSTANTS.modals.open, payload: { props } });
  };
}

export function closeModal(key) {
  return dispatch => {
    return dispatch({ type: ACTION_CONSTANTS.modals.close, payload: { key } });
  };
}



// WEBPACK FOOTER //
// ./src/actions/modals.js